import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { SvgIconProps } from "@mui/material";

interface Controls {
  label: string;
  style: string;
  type: string;
  testId: string;
  Icon?: React.ComponentType<SvgIconProps>;
}

export const CONTROLS = [
  { label: "H1", style: "header-one", type: "block", testId: "h1-btn-wysiwyg" },
  { label: "H2", style: "header-two", type: "block", testId: "h2-btn-wysiwyg" },
  {
    label: "H3",
    style: "header-three",
    type: "block",
    testId: "h3-btn-wysiwyg",
  },
  {
    label: "UL",
    Icon: FormatListBulletedIcon,
    style: "unordered-list-item",
    type: "block",
    testId: "ul-btn-wysiwyg",
  },
  {
    label: "OL",
    Icon: FormatListNumberedIcon,
    style: "ordered-list-item",
    type: "block",
    testId: "ol-btn-wysiwyg",
  },
  {
    label: "Bold",
    Icon: FormatBoldIcon,
    style: "BOLD",
    type: "inline",
    testId: "bold-btn-wysiwyg",
  },
  {
    label: "Italic",
    Icon: FormatItalicIcon,
    style: "ITALIC",
    type: "inline",
    testId: "italic-btn-wysiwyg",
  },
  {
    label: "Underline",
    Icon: FormatUnderlinedIcon,
    style: "UNDERLINE",
    type: "inline",
    testId: "underline-btn-wysiwyg",
  },
] as Controls[];
